import React from "react";
import "./style.css";
import "../screens/style.css";

const OurTeam = () => {
  return (
    <div className="intro">
      <div className="back">
        <img src="./images/back.jpg" className="w-100" alt="" />
        <div className="inner-head">
          <h3>Our Team</h3>
          <span>About Us &gt;&gt; Our Team</span>
        </div>
      </div>
      <div className="p-lg-5 pt-4 pb-4">
        <div className="pt-lg-5 bod">
          <div className="col-md-10 offset-md-1">
            <div className="row">
              <div className="col-lg-3">
                <img
                  src="./images/binod.jpg"
                  className="w-100 p-2 m-lg-3"
                  alt=""
                />
              </div>
              <div className="col-lg-9 p-md-4">
                <div className="mb-4">
                  <h4>Mr. Binod Kumar Sharma</h4>
                  <p>
                    <i>Chief Executive Manager</i>
                  </p>
                  <p className="work_title">Experience:</p>
                  <ul>
                    <li>
                      Mr. Binod Sharma is one of renowned banker having worked
                      with several banks for more than 30 years. <br />{" "}
                      Currently he is BOD at Muktinath Bikas Bank.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-lg-3">
                <img
                  src="./images/ajeet.jpg"
                  className="w-100 p-2 m-lg-3"
                  alt=""
                />
              </div>
              <div className="col-lg-9 p-md-4">
                <div className="mb-4">
                  <h4>Mr. Ajeet Bikram Karki</h4>
                  <p>
                    <i>Chief Executive Engineer</i>
                  </p>
                  <p className="work_title">Experience:</p>
                  <ul>
                    <li>More than 20 years of experience</li>
                    <li>Hydropower Infrastructure Specialist</li>
                    <li>
                      Completed Upper Dordi ‘A’ Hydroelectric Project (25 MW)
                    </li>
                    <li>Technical Head at Happy Energy Pvt. Ltd.</li>
                  </ul>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-lg-3">
                <img
                  src="./images/mahesh.jpg"
                  className="w-100 p-2 m-lg-3"
                  alt=""
                />
              </div>
              <div className="col-lg-9 p-md-4">
                <div className="mb-4">
                  <h4>Mr. Mahesh Prasad Kafle</h4>
                  <p>
                    <i>Management Expert</i>
                  </p>
                  <p className="work_title">Experience:</p>
                  <ul>
                    <li>
                      Director at Garima Capital Ltd. Website:
                      https://garimacapital.com/board-of-directors
                    </li>
                    <li>Former CEO of Kamana Sewa Bikash Bank Ltd.</li>
                    <li>Former-Director: Sahara Bikas Bank Ltd.</li>
                    <li>Former Campus Chief: Achham Multiple Campus</li>
                    <li>
                      Former-Director: Chautari Microfinance Institution Ltd.
                    </li>
                    <li>Executive Chairman: Kings Holiday Pvt. Ltd.</li>
                    <li>
                      Executive Chairman: Sewa Investment &amp; International
                      Group Pvt. Ltd.
                    </li>
                    <li>
                      Director: SP Group of Engineering &amp; Associates Pvt.
                      Ltd.
                    </li>
                    <li>Chairman: Blooming Engineering Consult Pvt. Ltd.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurTeam;
